import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import React, { Suspense } from 'react';
import { RecoilRoot } from 'recoil';

import * as Sentry from "@sentry/react";

import axios from 'axios';

import Loader from './components/loader';
import ErrorView from './components/errorView';

import lazyWithRetry from './utils/lazyWithRetry';

import './assets/scss/main.scss';

import { API_URL } from './vars';

const StateHydrate = lazyWithRetry(() => import('./hydrators/stateHydrate'));
const RoutesHydrate = lazyWithRetry(() => import('./hydrators/routesHydrate'));
const ProvidersHydrate = lazyWithRetry(() => import('./hydrators/providersHydrate'));

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

axios.interceptors.request.use(config => {
    const token = localStorage.getItem('tokenState');
    const url = config.url || '';

    config.headers = config.headers || {};

    if (config.headers.Authorization && !`${config.headers.Authorization}`.startsWith('Bearer ')) {
        config.headers.Authorization = `Bearer ${config.headers.Authorization}`;
    } else if (token && !config.headers.Authorization && !url.startsWith('http')) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    const pathMap = {
        '/weblogin': '/auth/weblogin',
        '/routing': '/generateRoute',
        '/orgPost': '/save',
        '/listPost': '/list/post',
        '/profilePhoto': '/media/avatar',
        '/orgMedia': '/media/upload',
        '/fastmedia': '/media/upload',
        '/saveWeb': '/save/web',
    };

    if (pathMap[url]) {
        config.url = pathMap[url];
    }

    return config;
});

Sentry.init({
    dsn: "https://4ec3f343f5c9a78ae45c84cb48c6b9cc@o4508315036155904.ingest.us.sentry.io/4508315043299328",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
    sendDefaultPii: true,
    integrations: [
    ],
});



const root = createRoot(document.getElementById('root'));

root.render(
    <RecoilRoot>
        <BrowserRouter>
            <Sentry.ErrorBoundary fallback={ErrorView}>


                <Suspense fallback={<Loader splash />}>
                    <ProvidersHydrate>
                        <StateHydrate>
                            <RoutesHydrate />
                        </StateHydrate>
                    </ProvidersHydrate>
                </Suspense>
            </Sentry.ErrorBoundary>
        </BrowserRouter>
        <Loader
            main
        />
    </RecoilRoot>
);

